import { render, staticRenderFns } from "./AcuteLowerLimbIschemiaGrading.vue?vue&type=template&id=f3c14476&scoped=true&"
import script from "./AcuteLowerLimbIschemiaGrading.vue?vue&type=script&lang=js&"
export * from "./AcuteLowerLimbIschemiaGrading.vue?vue&type=script&lang=js&"
import style0 from "./AcuteLowerLimbIschemiaGrading.vue?vue&type=style&index=0&id=f3c14476&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c14476",
  null
  
)

export default component.exports